<div class="login-page" *ngIf="!hideRest">
    <nav class="navbar navbar-expand-lg fixed-top navbar-light">
        <div class="container">
            <a class="navbar-brand logo-image" href="">
                <img src="assets/images/xchange.png" alt="alternative"></a>
        </div> <!-- end of container -->
    </nav>
    <div class="login-left">
        <div class="left-login">


            <div>
                <div class="text-primary  ">
                    <h5 id="reg" class="text-primary welcome-title ">Register</h5>
                    <p id="para" class="welcome-subtitle">Please provide the required information.</p>
                </div>


                <!-- 
<div id="pop" *ngIf="!hideRest" class="p-0">
    <div class="header">
        <div class="row">
            <div class="col-lg-12 col-12">
                <div class="byr mt-5 text-center">
                    <h4> Registrations </h4>
                </div>
            </div>
        </div>
    </div> -->

                <!-- <div class="container-fluid "> -->
                <div class="row">

                    <!-- <div class="col-lg-3"></div> -->

                    <div class="col-lg-12 ">
                        <div class="tab-content" id="myTabContent">




                            <div class="tab-pane fade show active" id="contact1" role="tabpanel"
                                aria-labelledby="contact-tab1">
                                <div class="ul-tab-content">
                                    <!-- <div class="tab-content card_2 p-5" id="myTabContentJust"> -->
                                    <div id="myTabContentJust">
                                        <div class="row">
                                            <div class="col-12">
                                                <ngb-alert type="success" *ngIf="responseMessage" [dismissible]="false">
                                                    {{responseMessage | titlecase}}
                                                </ngb-alert>
                                                <ngb-alert type="warning" *ngIf="errorMessage" [dismissible]="false">
                                                    {{errorMessage | titlecase}}
                                                </ngb-alert>
                                            </div>
                                            <div class="col-md-12">
                                                <form [formGroup]="registerForm" #formDir="ngForm"
                                                    (ngSubmit)="onSubmitRegisterForm()">
                                                    <!-- <div class="col-md-12"> -->

                                                    <div class="form-group col-lg-12">
                                                        <div class="form-check form-check-inline label-container">
                                                            <label class="form-check-label">
                                                                <input class="form-check-input" type="radio"
                                                                    formControlName="register_as" value="1"
                                                                    name="register_as"
                                                                    (click)="funcsubtitle($event)">Individual
                                                            </label>
                                                        </div>
                                                        <div class="form-check form-check-inline label-container">
                                                            <label class="form-check-label">
                                                                <input class="form-check-input" type="radio"
                                                                    formControlName="register_as" value="2"
                                                                    name="register_as"
                                                                    (click)="funcsubtitle($event)">Company
                                                            </label>
                                                        </div>
                                                        <!-- <div class="form-check form-check-inline col-lg-6">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="radio"
                                                            formControlName="register_as" value="1" name="register_as"
                                                            (click)="funcsubtitle($event)">Individual
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline radio  col-lg-6">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="radio"
                                                            formControlName="register_as" value="2" name="register_as"
                                                            (click)="funcsubtitle($event)">Company
                                                    </label>
                                                </div> -->
                                                        <!-- <div class="inputs hidden">
                                                        <input type="text">
                                                        <input type="text">
                                                    </div> -->
                                                        <div class="invalidError"
                                                            *ngIf="(registerForm.get('register_as').invalid && formDir.submitted)">
                                                            Register as is required*</div>
                                                    </div>
                                                    <div class="form-group" *ngIf="shown">
                                                        <label class="control-label"> Company Name<span
                                                                style="color: crimson;">*</span></label>
                                                        <input (keydown)="allowOnlyAlphabets($event)" maxlength="100"
                                                            type="text" formControlName="companies" required="required"
                                                            class="form-control" placeholder="Enter Company Name" />
                                                        <div class="invalidError"
                                                            *ngIf="(registerForm.get('companies').invalid && formDir.submitted)">
                                                            Company Name is required*</div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group col-lg-6">
                                                            <label class="control-label"> First Name<span
                                                                    style="color: crimson;">*</span></label>
                                                            <input (keydown)="allowOnlyAlphabets($event)"
                                                                maxlength="100" type="text" formControlName="first_name"
                                                                required="required" class="form-control"
                                                                placeholder="First Name" />
                                                            <div class="invalidError "
                                                                *ngIf="(registerForm.get('first_name').invalid && formDir.submitted)">
                                                                First Name is required*</div>
                                                        </div>
                                                        <div class="form-group col-lg-6">
                                                            <label class="control-label"> Last Name<span
                                                                    style="color: crimson;">*</span></label>
                                                            <input (keydown)="allowOnlyAlphabets($event)"
                                                                maxlength="100" type="text" formControlName="last_name"
                                                                required="required" class="form-control"
                                                                placeholder="Last Name" />
                                                            <div class="invalidError"
                                                                *ngIf="(registerForm.get('last_name').invalid && formDir.submitted)">
                                                                Last Name is required*</div>
                                                        </div>
                                                    </div>
                                                    <div class="form-group col-lg-12">
                                                        <label class="control-label"> Email ID<span
                                                                style="color: crimson;">*</span></label>
                                                        <input maxlength="100"  type="email"
                                                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                                            formControlName="email" required="required"
                                                            class="form-control" placeholder="Email" />
                                                        <div class="invalidError"
                                                            *ngIf="(registerForm.get('email').invalid && formDir.submitted)">
                                                            Email is required*</div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="form-group col-lg-4">
                                                            <label class="control-label"> Country<span
                                                                    style="color: crimson;">*</span></label>
                                                            <select class="form-control" formControlName="country"
                                                                (change)="onSelectCountry(registerForm.get('country').value)">
                                                                <option value="" selected disabled>Select
                                                                </option>
                                                                <option *ngFor="let option of countryCodesList"
                                                                    [ngValue]="option.name">{{option.name | titlecase}}
                                                                </option>
                                                            </select>
                                                            <div class="invalidError"
                                                                *ngIf="(registerForm.get('country').invalid && formDir.submitted)">
                                                                Country is required*</div>
                                                        </div>
                                                        <div class="form-group col-md-8">

                                                            <!-- <div class="row"> -->
                                                            <!-- <div class="col-md-4">
                                                                    <label class="control-label"> code<span
                                                                            style="color: crimson;">*</span></label>
                                                                    <input type="text" class="form-control" disabled
                                                                        formControlName="country_code">
                                                                </div> -->
                                                            <!-- <div class="col-md-8"> -->
                                                            <label class="control-label"> Mobile Number<span
                                                                    style="color: crimson;">*</span></label>
                                                            <!-- <input type="text" formControlName="phone" pattern="[1-9]{1}[0-9]{9}" (keypress)="isNumber($event)" required class="form-control" placeholder="Enter Phone Number"> -->
                                                            <input type="text" formControlName="phone"
                                                                (keypress)="isNumber($event)" required
                                                                class="form-control" [maxlength]=maxD
                                                                placeholder="Enter Mobile Number">
                                                            <div class="invalidError"
                                                                *ngIf="(registerForm.get('phone').invalid && formDir.submitted)">
                                                                Phone No is required*</div>
                                                            <!-- </div> -->
                                                            <!-- </div> -->
                                                        </div>
                                                    </div>
                                                    <div class="row" *ngIf="!isSwitchMode">
                                                        <div class="form-group col-md-6">
                                                            <label class="control-label">Enter Password<span
                                                                    style="color: crimson;">*</span></label>
                                                            <input [type]="hide ? 'password' : 'text'" type="password"
                                                                formControlName="password" required="required"
                                                                class="form-control password" />
                                                            <button class="btn btn-light ms-0" (click)="showPassword()"
                                                                type="button" id="password-addon">
                                                                <!-- <i
                                                                    class="mdi mdi-eye-outline"></i> -->
                                                                <img src="assets/newImages/eyebutton.png" alt="">
                                                            </button>
                                                            <div class="invalidError"
                                                                *ngIf="(registerForm.get('password').invalid && formDir.submitted)">
                                                                Password is required, must be alphanumeric, and at least
                                                                6
                                                                characters long</div>


                                                        </div>
                                                        <div class="form-group col-md-6">
                                                            <label class="control-label">Re-Enter Password<span
                                                                    style="color: crimson;">*</span></label>
                                                            <input [type]="hides ? 'password' : 'text'" type="password"
                                                                formControlName="rpassword" required="required"
                                                                class="form-control password" />
                                                            <button class="btn btn-light ms-0" (click)="showPassword2()"
                                                                type="button" id="password-addon">
                                                                <img src="assets/newImages/eyebutton.png" alt="">

                                                                <!-- <i
                                                                    class="mdi mdi-eye-outline"></i> -->
                                                            </button>
                                                            <div *ngIf="(registerForm.get('rpassword').invalid && formDir.submitted)"
                                                                class="invalidError">Retype Password is required, must
                                                                be
                                                                alphanumeric, and at least 6 characters long</div>
                                                            <div *ngIf="registerForm.get('rpassword').dirty"
                                                                class="invalidError">
                                                                <span *ngIf="registerForm.errors?.invalid">
                                                                    Password doesn't match*
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="isSwitchMode" class="alert alert-info mt-2">
   You will continue using your existing password for login.
</div>
                                                    <!-- <div class="form-group mb-3">
                                                    <div>
                                                        <label for="type" class="form-label">Type*</label>
                                                    </div>
                                                    <div class="form-check form-check-inline">
                                                        <label class="form-check-label">
                                                            <input class="form-check-input" type="radio" formControlName="type" value="1" name="type">Buyer
                                                        </label>
                                                    </div>
                                                    <div class="form-check form-check-inline">
                                                        <label class="form-check-label">
                                                            <input class="form-check-input" type="radio" formControlName="type" value="2" name="type">Seller
                                                        </label>
                                                    </div>
                                                   
                                                    <div class="invalidError" *ngIf="(registerForm.get('type').invalid && formDir.submitted)">
                                                        <div>Type is required*</div>
                                                    </div>
                                                </div> -->

                                                    <!-- <div class="form-group">
                                                    <label for="">Type</label>
                                                    <div>
                                                        <button class="btn" [ngClass]="(registerType == 1)? 'btn-success': 'btn-danger'">
                                                            <i class="fa text-white" [ngClass]="(registerType == 1)? 'fa-check-circle': 'fa-times-circle'"></i>
                                                            As Buyer
                                                        </button> &nbsp;
                                                        <button class="btn btn-danger" [ngClass]="(registerType == 2)? 'btn-success': 'btn-danger'">
                                                            <i class="fa text-white" [ngClass]="(registerType == 2)? 'fa-check-circle': 'fa-times-circle'"></i>
                                                            As Seller
                                                        </button> &nbsp;
                                                        <button class="btn btn-danger" [ngClass]="(registerType == 3)? 'btn-success': 'btn-danger'">
                                                            <i class="fa text-white" [ngClass]="(registerType == 3)? 'fa-check-circle': 'fa-times-circle'"></i>
                                                            As Service Provider
                                                        </button>
                                                    </div>
                                                </div> -->
                                                    <!-- </div> -->
                                                    <div class="mb-1">
                                                        <div class="tacbox">
                                                            <input id="checkbox" type="checkbox"
                                                                formControlName="acceptTerms"
                                                                [ngClass]="{ 'is-invalid': formDir.submitted && registerForm.get('acceptTerms')?.errors }" />
                                                            <label for="checkbox" id="term_condition"> I agree to these
                                                                <a href="javascript: void(0);"
                                                                   >Terms and
                                                                    Conditions</a>.</label>
                                                            <div *ngIf="formDir.submitted && registerForm.get('acceptTerms')?.errors"
                                                                class="invalid-feedback">To continue, kindly accept
                                                                the Terms and Conditions*</div>
                                                            <p class="mb-0">By registering you agree to the Connect <a
                                                                    href="javascript: void(0);"
                                                                  
                                                                    class="text-primary">Terms of
                                                                    Use</a></p>

                                                        </div>
                                                    </div>
                                                    <div class="">
                                                        <div class=" d-grid">
                                                            <button class="btn btn-primary"
                                                                type="submit">Register</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3"></div>


                </div>
            </div>
        </div>
<div class="login-footer">© 2025 Content Market Place. Crafted with <i class="mdi mdi-heart text-danger"></i>  by Connekkt Xchange</div>

    </div>
    <div class="login-right">
        <div class="poster-overlay"></div>
        <p class="right-text">Lead your content to global success with us.</p>
    </div>
    <div class="container" *ngIf="hideRest">
        <div class="row">
            <div class="col-lg-12">
                <div class="mb-5">
                    <!-- <h1 class="display-2 fw-medium">4<i class="bx bx-buoy bx-spin text-primary display-3"></i>4</h1> -->
                    <!-- <h4 class="text-uppercase">{{this.message}}</h4> -->
                    <!-- <div class="mt-5 text-center">
                    <a class="btn btn-primary" routerLink="/account/register-email">Back to Signup</a>
                </div> -->
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-12 col-xl-6 text-center">
                <div style="top: 40%; position: fixed;">
                    <img src="assets/images/load.gif" alt="" class="img-fluid" width="25%">
                </div>
            </div>
        </div>
    </div>
</div>